import PageComponent from '../../common/component/page-component';
import escape from '../../common/template/escape';

class CountDown extends PageComponent {

    constructor({
        root,
        element,
        contentBlockAttribute = 'contentBlock--countdown',
        dateAttribute = 'date',
    }) {
		super({root: root, element: element});
        this.escape = escape;
        this.contentBlockAttribute = contentBlockAttribute;
        this.dateAttribute = dateAttribute;
    }

    prepare() {
        this.contentBlock = this.element.querySelector(this.dataSelector(this.contentBlockAttribute));
        this.initializeCountDown();
    }

    initializeCountDown() {
        const countDownDateString = this.dataAttr(this.element).get(this.dateAttribute);
        const countDownDate = new Date(countDownDateString).getTime();

        if (Number.isNaN(countDownDate)) {
            return;
        }
        const countdown = setInterval(() => {
            // Get today's date and time
            const now = new Date().getTime();
            // Find the distance between now and the count down date
            const distance = countDownDate - now;
            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            // Output the result in the countdown elements
            this.element.querySelector('.ubf-countdown__number--days').innerHTML = days;
            this.element.querySelector('.ubf-countdown__number--hours').innerHTML = hours;
            this.element.querySelector('.ubf-countdown__number--minutes').innerHTML = minutes;
            this.element.querySelector('.ubf-countdown__number--seconds').innerHTML = seconds;
            // If the count down is over, no content will be shown
            if (distance < 0) {
                clearInterval(countdown);
                this.element.innerHTML = '';
            }
        }, 1000);
    }
}
export default CountDown;
